import { cn } from '../../lib/cn';
import type { ReturnRefundRow } from '../../customerops/framework';

type Props = { items?: ReturnRefundRow[] };

function statusColor(status: string) {
  switch (status) {
    case 'approved': return 'bg-success-100 text-success-700 dark:bg-success-950 dark:text-success-300';
    case 'pending_approval': return 'bg-warning-100 text-warning-700 dark:bg-warning-950 dark:text-warning-300';
    case 'received': return 'bg-brand-100 text-brand-700 dark:bg-brand-950 dark:text-brand-300';
    default: return 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400';
  }
}

export function ReturnsRefundsPanel({ items = [] }: Props) {
  return (
    <div className="space-y-2">
      {items.map((r) => (
        <div key={r.id} className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div>
            <div className="flex items-center gap-2">
              <span className="text-sm font-medium">{r.id}</span>
              <span className="rounded bg-slate-100 px-1.5 py-0.5 text-xs dark:bg-slate-800">{r.type}</span>
            </div>
            <p className="mt-0.5 text-xs text-slate-500">{r.reason} · {r.value}</p>
          </div>
          <span className={cn('shrink-0 rounded-full px-2 py-0.5 text-xs font-medium capitalize', statusColor(r.status))}>
            {r.status.replace('_', ' ')}
          </span>
        </div>
      ))}
    </div>
  );
}
